import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { VerificareAutoComponent } from './verificare-auto.component';

const routes: Routes = [
    {
        path: '',
        component: VerificareAutoComponent,
        data: {
            title: 'Verificare numar auto - Ridicari auto'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class VerificareAutoRoutingModule { }
